import { IMFile } from '@wui/im'

import { isImageFile, isVideoFile } from './type-helper'

type ImFileLike = Pick<IMFile, 'filemime' | 'filename'>

export const isImFileImage = (file: ImFileLike): boolean =>
  !!file.filemime?.includes('image/') || isImageFile(file.filename)

export const isImFileVideo = (file: ImFileLike): boolean =>
  !!file.filemime?.includes('video/') || isVideoFile(file.filename)

export const isImFileImageOrVideo = (file: ImFileLike): boolean =>
  isImFileImage(file) || isImFileVideo(file)
